import { Alert } from "react-native";
import { RESULTS, openSettings } from "react-native-permissions";
import { requestFileSharePermissions } from "@utils/permissions";

/**
 * Wraps an async function with a file-share permission gate.
 * If permission is blocked, shows a Hindi-language alert directing the user
 * to app settings.
 *
 * Usage: handleFSPermission(myFunction, arg1, arg2)
 */
type AnyFunction = (...args: unknown[]) => void;

export default async (executableFunc: AnyFunction, ...executableFuncArgs: unknown[]) => {

  const { granted, statuses } = await requestFileSharePermissions();

  if (granted) {
    executableFunc(...executableFuncArgs);
    return;
  }

  const isBlocked = Object.values(statuses).some(
    (result) => result === RESULTS.BLOCKED,
  );

  if (isBlocked) {
    Alert.alert(
      "Go to Settings",
      "CityMall को whatsapp शेयर करने के लिये आपके storage की परमिशन चाहिए |",
      [
        {
          text: "OK",
          onPress: () =>
            openSettings().catch(() => {}),
        },
      ],
      { cancelable: true },
    );
    return;
  }

  return Promise.reject("User won't give us permission");
};
